import { useEffect, useState } from "react"
import { useAuth } from "@/services/userService"
import { useNavigate } from "~/router"
import { HashLoader } from "react-spinners"
import { axiosErrorToStringError } from "@/utils/axiosErrorToStringError"
import { isAxiosError } from "axios"

export default function Logout() {

    /* hook utile à la redirection */
    const navigate = useNavigate()

    const [errorMessage, setErrorMessage] = useState(null);

    /* Le service API d'authentification et chargement du hook de logout */
    const { logoutHandler, setUser, setAccessToken, auth } = useAuth()
    //const logout = useLogout()
    
    /* Au chargement, on lance la procédure de logout */
    useEffect(() => {
        setErrorMessage(null);

        const asyncLogoutHandler = async () => {
            try {
                const fromIdp = auth.fromIdp

                await logoutHandler();
                setUser(null)
                setAccessToken(null)
    
                await new Promise(resolve => setTimeout(resolve, 3000));
                
                if (fromIdp) {
                    navigate('/login?noAuto=true', {replace: true})
                } else {
                    navigate('/login?local=true&noAuto=true', {replace: true})
                }

            } catch (error) {
                console.error('logout::error', error)
                if (isAxiosError(error)) {
                    setErrorMessage(axiosErrorToStringError(error))
                } else {
                    setErrorMessage(error?.message || "Erreur inconnue")
                }
            }
        }

        asyncLogoutHandler()

    }, []) //eslint-disable-line react-hooks/exhaustive-deps

    return (
        <div className="sm:py-8 h-screen">
            <div className="sm:mx-auto sm:w-full sm:max-w-lg sm:rounded-xl sm:border sm:border-gray-500 bg-white shadow-xl p-2 flex flex-col">
                <div>
                    <HashLoader size={20} className="mx-auto"/>
                    <h2 className="mt-4 text-center text-2xl font-bold leading-9 tracking-tight text-gray-9000">Déconnection</h2>
                </div>
                <div className="mt-10 text-center font-md">
                    <p>La déconnexion est en cours, vous allez être redirigé vers la page d&apos;authentification</p>
                    <p className="text-red-600">{errorMessage && errorMessage}</p>
                    <p className="text-red-600"></p>
                </div>
            </div>
        </div>
    )
}